import React from 'react';
import './Hero.css';
import heroImage from '../../assets/images/courses-banner_edited.jpg';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Why Home Aide CNA Bridge Training Center?</h1>
            <p>
              We provide our students with the cutting-edge training that equips them to handle the challenges presented by the day-to-day responsibilities of the professional health care environment. The class offerings are structured and scheduled to offer an affordable, flexible, and convenient alternative that still provides top-quality, state-of-the-art training.
            </p>
            <p>
              Our small class sizes and technological learning aids make learning and retaining the information achievable. You will be a subject matter expert upon graduation from any of our programs.
            </p>
            <div className="hero-buttons">
              <a href="/courses" className="btn">View Courses</a>
              <a href="/contact" className="btn btn-outline">Contact Us</a>
            </div>
          </div>
          <div className="hero-image">
            <img src={heroImage} alt="Healthcare professionals in training" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;